module.exports = __webpack_public_path__ + "img/prepay-send.c54c33e1.png";